const product = {
  information: "Información", // translated
  additionalInformation: "información adicional", // translated
  contactUs: "Contáctenos", // translated
  contactUsText: "¿Quieres personalizar tu recorrido o tienes alguna otra pregunta?", // translated
  dropUsAnEmail: "Envíanos un correo electrónico", // translated
  viewLess: "ver menos", // translated
  viewMore: "Ver más", // translated
  less: "menos", // translated
  more: "más", // translated
  highlights: "Reflejos", // translated
  inclusions: "Inclusiones", // translated
  exclusions: "Exclusiones", // translated
  pleaseWait: "Espere por favor...", // translated
  tourType: "Tipo de viaje", // translated
  search: "Búsqueda", // translated
  available: "Disponible", // translated
  availableTours: "Tours disponibles", // translated
  sortBy: "ORDENAR POR", // translated
  priceLowToHigh: "Precios de barato a caro", // translated
  priceHighToLow: "Precio: de mayor a menor", // translated
  mostPopular: "Más popular", // translated
  roomOnly: "Solo Habitación", // translated
  bedAndBreakfast: "Cama y Desayuno", // translated
  halfBoard: "Madia pizarra", // translated
  fullBoard: "Pensión completa", // translated
  allInclusive: "Todo incluido", // translated
  viewDetails: "Ver detalles", // translated
  close: "Cerrar", // translated
  at: "En", // translated
  person: "persona", // translated
  cancellationPolicy: "Política de cancelación", // translated
  cancellationIs: "la cancelación es", // translated
  to: "para", // translated
  bookingRemarks: "Comentarios de la reserva", // translated
  totalPrice: "Precio total", // translated
  back: "Atrás", // translated
  bookNow: "Reservar ahora", // translated
  minutes: "Minutos", // translated
  visitDuration: "Duración de la visita", // translated
  itinerary: "Itinerario", // translated
  airportToHotel: "Aeropuerto a Hotel", // translated
  hotelToAirport: "Hotel al aeropuerto", // translated
  details: "detalles", // translated
  servicesDetails: "Detalles de los servicios", // translated
  services: "Servicios", // translated
  day: "Día", // translated
  next: "próximo", // translated
  nextStep: "Próximo paso", // translated
  skip: "Saltear", // translated
  remarks: "Observaciones", // translated
  optional: "Opcional", // translated
  guests: "Huéspedes", // translated
  payment: "Pago", // translated
  pickup: "recoger", // translated
  featuredPackage: "Paquete destacado", // translated
  flights: "Vuelos", // translated
  accommodation: "Alojamiento", // translated
  transfers: "Transferencias", // translated
  tours: "Excursiones", // translated
  experiences: "Experiencias", // translated
  featuredTour: "Tour destacado", // translated
  From: "Desde", // translated
  Accommodation: "Alojamiento", // translated
  approxDuration: "Aprox. duración", // translated
  travellerInformation: "Información del viajero", // translated
  bookingOverview: "Descripción general de la reserva", // translated
  checkout: "Verificar", // translated
  paymentFailed: "Pago fallido", // translated
  paymentSuccess: "pago exitoso", // translated
  night: "Noche", // translated
  viewEscapes: "Ver Escapar", // translated
  escapeType: "Tipo de escape", // translated
  adultsOnly: "Sólo para adultos", // translated
  totalDuration: "Duración total", // translated
  options: "Opciones", // translated
  childrenAreNotAllowedInThisTour: "No se permiten niños en este tour.", // translated
  departingAirport: "Aeropuerto de salida", // translated
  product: "Producto", // translated
  nights: "Noches", // translated
  products: "Productos", // translated
  viewExperience: "Ver experiencia", // translated
};


export default product;
